import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportsComponent } from './reports.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { MultiSelectModule } from 'primeng/multiselect';
import { DropdownModule } from 'primeng/dropdown';
import { LoaderWrapperModule } from '../loader-wrapper/loader-wrapper.module';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatIconModule } from '@angular/material/icon';
import { PaginatorModule } from 'primeng/paginator';
import { SharedModule } from '../shared/shared.module';
import { CalendarModule } from 'primeng/calendar';
import { TooltipModule } from 'primeng/tooltip';
import { RouterModule } from '@angular/router';
import { SidebarModule } from 'primeng/sidebar';

@NgModule({
  declarations: [ReportsComponent],
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: '',
        component: ReportsComponent,
      },
    ]),
    FormsModule,
    InputTextModule,
    ButtonModule,
    TableModule,
    MultiSelectModule,
    DropdownModule,
    LoaderWrapperModule,
    ConfirmDialogModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatIconModule,
    PaginatorModule,
    SharedModule,
    CalendarModule,
    TooltipModule,
    SidebarModule,
  ],
  exports: [ReportsComponent],
  providers: [ConfirmationService],
})
export class ReportsModule {}
